import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Initialize Sentry as early as possible
Sentry.init({
  dsn: "https://6fc0dc3a8b1c71501d2a7dbd03b3811a@o4509584437608448.ingest.us.sentry.io/4509584444227584",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

createRoot(document.getElementById('root')!).render(
  <App />
)
